import { useEffect, useState } from 'react';
import styles from './Automation.module.css';
import TooltipIconButton from 'components/UI/Buttons/TooltipIconButton/TooltipIconButton';
import bugImage from 'assets/bug.png';
import { AUTOMATION_SOURCE, AUTOMATION_SOURCE_TOOLTIP, OVERWRITTEN_STYLE_NOT_ALLOWED_SOURCES } from 'utils/constants';
import AIDetectionIcon from 'components/icons/AIDetectionIcon';
import { Tooltip } from '@mui/material';

function Automation({ disabled, automation, issues, autoTooltip, onBugIconClick }) {
    const { source, info, sourceValue } = automation || {};
    const [initial, setInitial] = useState(true);
    const [automationOverwritten, setAutomationOverwritten] = useState(false);
    const normalizedSource = source?.toString().toUpperCase();
    const normalizedValue = sourceValue?.toString().toUpperCase();
    const isValueUnknown = !sourceValue || normalizedValue === 'UNKNOWN' || normalizedValue === '?';
    const showAIDetection = normalizedSource === 'ALISA' && isValueUnknown;

    useEffect(() => {
        if (!source || !sourceValue) {
            return;
        }
        if (initial) {
            setInitial(false);
            return;
        }
        const allowOverwrittenStyles = !OVERWRITTEN_STYLE_NOT_ALLOWED_SOURCES.includes(source);
        setAutomationOverwritten(allowOverwrittenStyles);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [source, info, sourceValue]);

    const containerStyles = `${styles['automation-container']}${disabled ? ` ${styles['automation-container--disabled']}` : ''}`;
    const tooltip = (source === AUTOMATION_SOURCE.AUTO && autoTooltip) || AUTOMATION_SOURCE_TOOLTIP[source] || '';
    const hasSuggestion = !(sourceValue === undefined || sourceValue === null || sourceValue === '');

    return (
        <>
            {issues && (
                <TooltipIconButton clickHandler={onBugIconClick} classes={styles['automation-bug-icon']} iconImage={bugImage} title="Report Issue" />
            )}

            {hasSuggestion && (
                <div className={containerStyles}>
                    {showAIDetection ? (
                        <div className={styles['automation-container--value']}>
                            <Tooltip
                                title="AI has detected an object, but could not determine the value."
                                placement="top"
                                disableHoverListener={!isValueUnknown}
                            >
                                <span className={styles['automation-detection-icon']}>
                                    <AIDetectionIcon size={15} />
                                </span>
                            </Tooltip>
                        </div>
                    ) : (
                        <Tooltip title={String(sourceValue)} placement="top" disableHoverListener={!sourceValue}>
                            <div className={styles['automation-container--value']}>
                                <p className={source === AUTOMATION_SOURCE.AUTO ? styles['automation-auto-value'] : ''}>{sourceValue}</p>
                            </div>
                        </Tooltip>
                    )}

                    <span className={styles['automation-divider']} aria-hidden="true" />

                    <div className={styles['automation-container--source']}>
                        <Tooltip title={tooltip} placement="top" disableHoverListener={!tooltip}>
                            <p
                                className={
                                    source === AUTOMATION_SOURCE.AUTO
                                        ? styles['automation-auto']
                                        : source === AUTOMATION_SOURCE.AI_OCR
                                          ? styles['automation-ocr']
                                          : automationOverwritten
                                            ? styles['automation-overwritten']
                                            : ''
                                }
                            >
                                {source}
                            </p>
                        </Tooltip>
                    </div>
                </div>
            )}
        </>
    );
}

export default Automation;
